import React, { useEffect, useState } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Autocomplete,
    TextField,
    Divider,
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import axiosInstance from '../../axiosInstance';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const QuoteDetailsEditModal = ({ selectedOption, setSelectedOption, modalType, setModalType, setSelectedCourse, editOpen, handleEditClose, selectedCourse, onUpdate }) => {
    const { t, i18n } = useTranslation();

    const [historyCheck, setHistoryCheck] = useState(true);
    const lightMode = useSelector((state) => state.mode.lightMode);

    const [providers, setProviders] = useState([]);
    const [residences, setResidences] = useState([]);
    const [accommodations, setAccommodations] = useState([]);

    const [provider, setProvider] = useState(null);
    const [residence, setResidence] = useState(null);
    const [accommodation, setAccommodation] = useState(null);
    const [checkIn, setCheckIn] = useState(null);
    const [checkOut, setCheckOut] = useState(null);
    const [durationValue, setDurationValue] = useState(0);
    const [durationUnit, setDurationUnit] = useState('Day');

    const [hasPrice] = useState(true);
    const [price, setPrice] = useState('');
    const [currency, setCurrency] = useState('GBP');

    const paraFormat = (number) => {
        const formatter = new Intl.NumberFormat("en-GB", {
            style: "currency",
            currency: "GBP",
        });
        return formatter.format(number);
    };

    async function getProviders() {
        const accessToken = localStorage.getItem("accessToken");
        const token = localStorage.getItem("loginUser");
        try {
            const params = new URLSearchParams();
            const url = `${process.env.REACT_APP_BASE_URL}booking/providers`;
            const response = await axiosInstance.post(url, params, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    XRefreshToken: `${token}`,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            setProviders(response.data.result);
        } catch (error) {
            console.error("Error during the request:", error.message);
        }
    }

    console.log(selectedOption, 'selected option here');

    async function getResidences(partnerId) {
        try {
            const formData = new FormData();
            formData.append("partners", partnerId || "");

            const accessToken = localStorage.getItem("accessToken");
            const token = localStorage.getItem("loginUser");
            const url = `${process.env.REACT_APP_BASE_URL}booking/campuses`;

            const response = await axiosInstance.post(url, formData, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    XRefreshToken: `${token}`,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            setResidences(response.data.result);
            if (!historyCheck) {
                // setResidence(null);
            }
        } catch (error) {
            console.error("Error during the request:", error.message);
        }
    }

    async function getRoomTypes(partnerIds, residenceIds) {
        try {
            const params = new URLSearchParams();
            params.append("partners", partnerIds);
            params.append("residences", residenceIds);

            const accessToken = localStorage.getItem("accessToken");
            const token = localStorage.getItem("loginUser");
            const url = `${process.env.REACT_APP_BASE_URL}booking/room_types`;

            const response = await axiosInstance.post(url, params, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    XRefreshToken: `${token}`,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            setAccommodations(response.data.result || []);
            if (!historyCheck) {
                // setAccommodation(null);
            }
        } catch (error) {
            console.error("Error during the request:", error.message);
        }
    }

    async function handleGetPrice(residenceId, accommodationId, checkIn, checkOut) {
        try {
            const params = new URLSearchParams();
            params.append("campus_id", residenceId || null);
            params.append("course_id", accommodationId || null);
            params.append("start_date", dayjs(checkIn).format("YYYY-MM-DD"));
            params.append("end_date", dayjs(checkOut).format("YYYY-MM-DD"));

            const accessToken = localStorage.getItem("accessToken");
            const token = localStorage.getItem("loginUser");
            const url = `${process.env.REACT_APP_BASE_URL}get_price`;

            const response = await axiosInstance.post(url, params, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    XRefreshToken: `${token}`,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            setPrice(response?.data?.total_price || '');

        } catch (error) {
            setPrice(null)
            console.error("Error during the request:", error);
        }
    }

    useEffect(() => {
        if (checkIn && checkOut) {
            const diff = dayjs(checkOut).diff(dayjs(checkIn), durationUnit.toLowerCase()); // örnek: "day"
            setDurationValue(diff > 0 ? diff : 0); // negatif çıkarsa 0 yap
        } else {
            setDurationValue(0);
        }
    }, [checkIn, checkOut, durationUnit]);

    useEffect(() => {
        if (editOpen) {
            getProviders();
            getResidences();
            getRoomTypes();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editOpen]);

    console.log(selectedCourse, 'sel course here');

    useEffect(() => {
        console.log(historyCheck, 'history check here');

    }, [historyCheck])
    useEffect(() => {
        if (editOpen && selectedCourse && historyCheck) {
            console.log(accommodations, 'accs');
            console.log(selectedCourse.option_course_name, 'accs2');

            console.log(residences, 'accs 3');
            console.log(selectedCourse.option_course_campus, 'accs 4');

            if (providers?.length) {
                setProvider(
                    providers.find(p => p.partner_name === selectedCourse.option_course_partner) || null
                );
            }
            console.log(selectedCourse, 'selected course here 61');

            if (accommodations?.length) {
                setAccommodation(
                    accommodations.find(p => p.course_id === selectedCourse.course?.course_id) || null
                );
            }

            if (residences?.length) {
                setResidence(
                    residences.find(p => p.campus_id === selectedCourse.course?.campus?.campus_id) || null
                );
            }


            setCheckIn(dayjs(selectedCourse.option_course_start_date));
            setCheckOut(dayjs(selectedCourse.option_course_end_date));
            setDurationValue(selectedCourse.option_course_duration || '');
            setDurationUnit(selectedCourse.option_course_duration_unit || 'Day');
            // setPrice(selectedCourse.option_course_subtotal_price || '');
            setCurrency(selectedCourse.option_course_currency || 'GBP');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editOpen, selectedCourse, providers, accommodations, residences, historyCheck]);

    useEffect(() => {

        console.log(modalType, 'modal type');
        console.log(provider, 'modal type');

        if (modalType === "edit") {
            if (!historyCheck) {
                if (!provider) {
                    setResidences([]);
                    setResidence(null);
                    return;
                }
                getResidences(provider.partner_id);
            }
        } else {
            getResidences(provider.partner_id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [provider, historyCheck]);

    useEffect(() => {
        if (modalType === "edit") {
            if (!historyCheck) {
                if (!provider || !residence) {
                    setAccommodations([]);
                    setAccommodation(null);
                    return;
                }
                getRoomTypes(provider?.partner_id, residence?.campus_id);
            }
        } else {
            console.log(provider, 'provider here');
            console.log(residence, 'residence here');
            getRoomTypes(provider?.partner_id, residence?.campus_id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [provider, residence, historyCheck]);

    useEffect(() => {
        console.log(residence, 'resi here');

        if (provider && residence && accommodation && modalType === "edit") {
            setHistoryCheck(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [provider, residence, accommodation]);

    useEffect(() => {
        console.log(residence, 'residence');
        console.log(accommodation, 'accommodation');
        console.log(checkIn, 'checkIn');
        console.log(checkOut, 'checkOut');

        if (editOpen && residence && accommodation && checkIn && checkOut) {
            handleGetPrice(residence?.campus_id, accommodation?.course_id, checkIn, checkOut)
        } else {
            setPrice(null)
        }
    }, [residence, accommodation, checkIn, checkOut, editOpen]);


    useEffect(() => {
        if (!editOpen) {
            resetForm();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editOpen]);

    const resetForm = () => {
        setProvider(null);
        setResidence(null);
        setAccommodation(null);

        setProviders(null);
        setResidences(null);
        setAccommodations(null);

        setCheckIn(null);
        setCheckOut(null);
        setDurationValue('');
        setDurationUnit('Day');
        setPrice('');
        setCurrency('GBP');
        setHistoryCheck(true);
        setModalType("edit");
        setSelectedCourse(null)
    };

    console.log(price, 'price here');


    const handleSave = () => {
        console.log(selectedCourse, 'selected course');

        onUpdate({
            ...selectedCourse,
            option_id: selectedOption?.option_id,
            campus_id: residence.campus_id,
            course_id: accommodation.course_id,
            option_course_partner: provider.partner_name,
            option_course_campus: residence.campus_name,
            option_course_name: accommodation.course_name,
            option_course_start_date: checkIn?.format('YYYY-MM-DD'),
            option_course_end_date: checkOut?.format('YYYY-MM-DD'),
            option_course_duration: durationValue,
            option_course_duration_unit: durationUnit,
            option_course_price: price,
            option_course_currency: currency,
        });
        handleEditClose();
    };

    return (
        <Dialog open={editOpen} onClose={handleEditClose} maxWidth="md" fullWidth>
            <DialogTitle>{modalType === "edit" ? t("editAccommodation") : t("addAccommodation")} </DialogTitle>

            <DialogContent >
                <Divider sx={{
                    borderBottom: `1px dashed ${lightMode ? "#cecece" : "#333e47"}`,
                }} />
                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} md={6}>
                        <Autocomplete
                            options={providers}
                            value={provider}
                            getOptionLabel={(opt) => opt.partner_name}
                            onChange={(_, v) => {
                                setResidence(null)
                                setAccommodation(null)
                                setProvider(v)
                            }
                            }
                            renderInput={(params) => <TextField sx={{ textTransform: 'capitalize' }} {...params} label={t("provider")} />}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Autocomplete
                            options={residences}
                            value={residence}
                            getOptionLabel={(opt) => `${opt.campus_name}`}
                            onChange={(_, v) => {
                                setAccommodation(null)
                                setResidence(v)
                            }
                            }
                            renderInput={(params) => <TextField sx={{ textTransform: 'capitalize' }} {...params} label={t("residence")} />}
                            disabled={!provider}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Autocomplete
                            options={accommodations}
                            value={accommodation}
                            getOptionLabel={(opt) => `${opt.course_name}`}
                            onChange={(_, v) => setAccommodation(v)}
                            renderOption={(props, option) => (
                                <li {...props}>
                                    <div>
                                        <div style={{ fontWeight: 'bold' }}>{option.course_name}</div>
                                        <div style={{ color: '#6b7280', fontSize: '0.9rem' }}>{option.campus_name}</div>
                                    </div>
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField sx={{ textTransform: 'capitalize' }} {...params} label={t("accommodation")} />
                            )}
                            disabled={!residence}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={9}>
                                <TextField
                                    sx={{ textTransform: 'capitalize' }}
                                    disabled
                                    fullWidth
                                    label={t("duration")}
                                    type="number"
                                    value={durationValue}
                                    onChange={(e) => setDurationValue(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    sx={{ textTransform: 'capitalize' }}
                                    select
                                    fullWidth
                                    label={t("type")}
                                    value={durationUnit}
                                    onChange={(e) => setDurationUnit(e.target.value)}
                                    SelectProps={{ native: true }}
                                >
                                    <option style={{ textTransform: 'capitalize' }} value="Day">{t("day")}</option>
                                    <option style={{ textTransform: 'capitalize' }} value="Week">{t("week")}</option>
                                </TextField>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    sx={{ textTransform: 'capitalize' }}
                                    fullWidth
                                    type="text"
                                    label={t("price")}
                                    value={hasPrice ? paraFormat(price) : ""}
                                    onChange={(e) => {
                                        const raw = e.target.value.replace(/[^0-9.]/g, ""); // Sayısal değeri çıkar
                                        setPrice(raw);
                                    }}
                                    // disabled={!hasPrice}
                                    disabled
                                    InputProps={{
                                        /*        startAdornment: (
                                                   <InputAdornment position="start">
                                                       <Checkbox
                                                           disabled
                                                           checked={hasPrice}
                                                           onChange={(e) => setHasPrice(e.target.checked)}
                                                       />
                                                   </InputAdornment>
                                               ), */
                                        /*    endAdornment: (
                                               <InputAdornment position="end">
                                                   <Select
                                                       value={currency}
                                                       disabled
                                                       variant="standard"
                                                       disableUnderline
                                                       sx={{
                                                           '&::before': { borderBottom: 'none !important' },
                                                           '&::after': { borderBottom: 'none !important' },
                                                           '& .MuiSelect-standard': {
                                                               paddingRight: '0 !important',
                                                           },
                                                           minWidth: 60,
                                                           fontSize: '0.875rem',
                                                       }}
                                                   >
                                                       <MenuItem value="GBP">GBP</MenuItem>
                                                   </Select>
                                               </InputAdornment>
                                           ), */
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <LocalizationProvider
                                            dateAdapter={AdapterDayjs}
                                            adapterLocale={i18n.language === "cn" ? "zh-cn" : i18n.language}>
                                            <DatePicker
                                                label={t("checkIn")}
                                                value={checkIn}
                                                onChange={(newValue) => {
                                                    setCheckIn(newValue);
                                                    if (checkOut && dayjs(newValue).isAfter(checkOut)) {
                                                        setCheckOut(null); // geçersizleşirse sıfırla
                                                    }
                                                }}
                                                shouldDisableDate={(date) => {
                                                    // Eğer checkout varsa, check-in tarihi onun sonrasında olamaz
                                                    return checkOut ? date.isAfter(checkOut, 'day') : false;
                                                }}
                                                slotProps={{
                                                    textField: { fullWidth: true }
                                                }}
                                                sx={{ width: '100%' }}
                                            />
                                        </LocalizationProvider>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <LocalizationProvider
                                            dateAdapter={AdapterDayjs}
                                            adapterLocale={i18n.language === "cn" ? "zh-cn" : i18n.language}>
                                            <DatePicker
                                                label={t("checkOut")}
                                                value={checkOut}
                                                onChange={(newValue) => {
                                                    setCheckOut(newValue);
                                                    if (checkIn && dayjs(newValue).isBefore(checkIn)) {
                                                        setCheckIn(null); // geçersizleşirse sıfırla
                                                    }
                                                }}
                                                shouldDisableDate={(date) => {
                                                    // Eğer check-in varsa, check-out tarihi onun öncesinde olamaz
                                                    return checkIn ? date.isBefore(checkIn, 'day') : false;
                                                }}
                                                slotProps={{
                                                    textField: { fullWidth: true }
                                                }}
                                                sx={{ width: '100%' }}
                                            />
                                        </LocalizationProvider>
                                    </Grid>
                                </Grid>
                            </Grid>

                            {/*    <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    label="Price"
                                    type="number"
                                    value={price}
                                    onChange={(e) => setPrice(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Currency"
                                    value={currency}
                                    onChange={(e) => setCurrency(e.target.value)}
                                    SelectProps={{ native: true }}
                                >
                                    <option value="GBP">GBP</option>
                                    <option value="USD">USD</option>
                                    <option value="EUR">EUR</option>
                                </TextField>
                            </Grid> */}
                        </Grid>
                    </Grid>

                </Grid>
            </DialogContent>
            <DialogActions>
                <Button sx={{ textTransform: 'capitalize' }} onClick={handleEditClose}>{t("cancel")}</Button>
                <Button
                    sx={{ textTransform: 'capitalize' }}
                    variant="contained"
                    onClick={handleSave}
                    disabled={!provider || !residence || !accommodation || !checkIn || !checkOut || !price}
                >
                    {modalType === "edit" ? t("update") : t("add")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default QuoteDetailsEditModal;